import { useSelectorTyped } from 'common/store/useSelectorTyped';
import {
  getTeamsOrGroupsDropdownHidden,
  getCompanyDropdownHidden,
  RBACProductAreasValues
} from 'common/utils/rbacHelpers';
import { RBAC_PRODUCT_AREAS_WITH_DEFAULT } from 'common/constants/rbacProductAreas';
import { useRBACSettings } from 'common/hooks/useRBACSettings';

export function useDataAccessPolicies({
  productArea = RBAC_PRODUCT_AREAS_WITH_DEFAULT.DEFAULT,
}: {
  productArea: RBACProductAreasValues;
}) {
  const { hasRBACEnabled } = useRBACSettings();
  const { dataAccessPolicies } = useSelectorTyped(state => state.currentPerson);

  const isTeamsOrGroupsDropdownHidden = hasRBACEnabled && getTeamsOrGroupsDropdownHidden(
    productArea,
    dataAccessPolicies
  );

  const isCompanyDropdownHidden = hasRBACEnabled && getCompanyDropdownHidden(
    productArea,
    dataAccessPolicies
  );

  return {
    currentDataAccessPolicies: dataAccessPolicies,
    isTeamsOrGroupsDropdownHidden,
    isCompanyDropdownHidden,
    hasRBACEnabled,
  };
}
